<template>
    <div class="report-footer">
        <div v-if="!isFdaFriendly" class="disclaimer">
            <span>
                {{ $translate('chloe_report_disclaimer') }}
            </span>

            <div v-if="isFdaUnfriendly" class="fda-disclaimer">
                <div class="hl"></div>
                <span>{{ $translate('fda_disclaimer_investigational') }}</span>
                <br />
                <span>{{ $translate('fda_disclaimer_not_for_clinical_app') }}</span>
            </div>
        </div>

        <div class="clinic-footer">
            <div v-if="tenant.logoUrl" class="clinic-logo">
                <img :src="tenant.logoUrl" :alt="tenant.name" />
            </div>

            <div class="clinic-details">
                <span>{{ tenant.clinicName }}</span>
                <!-- <span>adress</span> -->
                <!-- <span>tel</span> -->
                <!-- <span>email</span>-->
            </div>

            <div class="chloe-details">
                <span>{{ pageNum }}</span
                >&nbsp;<span class="total-pages">/&nbsp;{{ totalPages }}</span>
                &nbsp;&nbsp;|&nbsp;&nbsp;
                <span>{{ reportTitle.toUpperCase() }}</span>

                <div v-if="!isFdaFriendly" class="chloe-eq-container">
                    <span class="our-clinic-uses">{{ $translate('our_clinic_uses') }}:</span>
                    <img src="/static/svg/chloe-eq-logo.svg" alt="Chloe-EQ by Fairtility" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ReportFooter',
    props: {
        reportTitle: {
            type: String,
            required: true
        },
        tenant: {
            type: Object,
            required: true
        },
        pageNum: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly',
            isFdaUnfriendly: 'common/isFdaUnfriendly'
        })
    }
}
</script>

<style lang="scss" scoped>
.report-footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .disclaimer {
        width: 100%;
        padding: 5px 10px;
        margin: 10px 0;
        font-size: 11px;
        display: flex;
        flex-direction: column;

        @media screen {
            background-color: #191f2650;
        }
        @media print {
            background-color: $light-2;
        }

        .hl {
            width: 100%;
            height: 0;
            margin-block: 5px;
            border-top: solid 0.5px $light;
        }
    }

    .clinic-footer {
        height: 76px;
        display: flex;
        justify-content: flex-start;
        padding: 15px 0 5px;

        @media screen {
            border-top: solid 2px $light;
        }
        @media print {
            border-top: solid 2px $report-color;
        }

        .clinic-logo {
            position: relative;
            width: 100px;
            height: 54px;
            margin-right: 30px;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                object-position: center center;
            }
        }

        .clinic-details {
            display: flex;
            align-items: center;
        }

        .chloe-details {
            display: flex;
            align-items: center;
            margin-left: auto;

            .total-pages {
                color: $light;
            }

            .chloe-eq-container {
                position: relative;
                height: 30px;
                width: 150px;
                margin-left: 20px;

                img {
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    object-position: right center;
                }

                .our-clinic-uses {
                    font-size: 11px;
                    position: absolute;
                    right: 0;
                    top: -20px;

                    @media screen {
                        color: $light-3;
                    }
                    @media print {
                        color: black;
                    }
                }
            }
        }
    }
}
</style>
